import services from '../services'
import * as types from './mutation-types'

export const GetPhotos = ({ commit }, params) => (
  services.listPhotos(params).then(res => {
    commit(types.SET_PHOTOS, res.data)
  })
)

export const GetPhoto = async ({ commit }, id) => {
  await services.getPhoto(id).then(res => {
    commit(types.SET_PHOTO, res.data.data)
  })
}

export const SavePhoto = async ({ commit }, obj) => {
  await services.savePhoto(obj).then(res => {
    commit(types.SET_PHOTO, res.data.data)
    return res
  })
}

export const orderList = async ({ commit }, obj) => {
  await services.orderList(obj).then(res => {
    return res.data
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const deletePhoto = async ({ commit }, obj) => {
  await services.deletePhoto(obj).then(res => {
    return res
  })
}
